import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'

Vue.use(Vuex);

const store = new Vuex.Store({
    state:{
        uid:'',//用户id
        nextPath:'',//下一页面路由名称
        nextTitle:'',//下一页面顶部导航title
        userInfo:{},//用户信息
        currentPickupInfo:{},//当前提货详情页需要的信息
        currentAddressInfo:'',//当前选中的地址信息
        currentPickupGoodsInfo:[],//提货商品确认页所需商品信息
        currentDhGoodsInfo:[],//确认兑换页所需商品信息
    },
    mutations:{
        setNextpath(state,nextpath){
            state.nextPath=nextpath;
        },
        setNextTitle(state,title){
            state.nextTitle=title;
        },
        setUid(state,uid){
            state.uid=uid;
        },
        removeUid(state){
            state.uid='';
        },
        setUserInfo(state,uinfo){
            state.userInfo=uinfo;
        },
        updateCurrentPickupInfo(state,info){
            state.currentPickupInfo=info;
        },
        setCurrentAddressInfo(state,info){
            state.currentAddressInfo=info;
        },
        setPickupGoodsInfo(state,data){
            state.currentPickupGoodsInfo=data;
        },
        setCurrentDhGoodsInfo(state,data){
            state.currentDhGoodsInfo=data;
        }
    },
    getters:getters
});

export {
    store
}